<template>


    <div v-if="cityShow">
        <!-- <div class="close_box" @click="closeBox"></div> -->
        <div ref='showPanel' v-if="cityCode == 1" class="city_search">
            <ul>
                <li v-for="(item,index) in citySearchList"
                    :key="index"
                    @click="clickCity(index,item)"
                >
                    <a href="javascript:;" v-html="item.checkedName" class=""></a>
                </li>
            </ul>
        </div>
        <div ref='showPanel' class="city_box" v-if="cityCode == 0">
            <div class="city_top">
                <a-radio-group :options="cityOptions" @change="groupCity" v-model="cityValue" />
            </div>
            <div class="clear city_div">
                <ul class="left">
                    <li :class="{'tab_active':index == tabIndex}"
                    v-for="(item,index) in tabList"
                    :key="index"
                    @click="clickTab(index,item)">
                        <a href="javascript:;">{{item}}</a>
                    </li>
                </ul>
                <ul class="left">
                    <li
                    v-for="(item,index) in cityList"
                    :key="index"
                    @click="clickCity(index,item)">
                        <a href="javascript:;">
                            <span :class="[{'tab_active_col':item.checked},'ellipsis city_span left']" :title="item.citynameen">{{item.citynameen}}</span>
                            <span class="right city_active" v-if="item.checked"></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
const cityOptions = [
    { label: 'China', value: 0 },
    { label: 'International', value: 1 },
];
const domesticHotCity = ["北京", "上海", "成都双流", "成都天府", "广州", "深圳", "三亚", "重庆", "西安", "九寨", "香港", "拉萨", "厦门", "杭州", "大连", "青岛", "武汉", "昆明", "台北", "丽江", "西双版纳"];
const InternationalHotCity = ["开罗","新加坡","东京","曼谷","首尔","普吉","圣彼得堡","迪拜","吉隆坡","大阪","悉尼","墨尔本","槟城","罗马","马德里","雅典"];
const doTab = ['Hot city','ABCDE','FGHIJ','KLMNO','PQRST','UVWXYZ']
const inTab = ['Hot city','Asia','North America','Oceania','Others']
export default {
  components: {},
  name: "Nav",
  data() {
    return {
        cityOptions,
        cityValue:0,
        cityList:[],
        tabIndex:0,
        tabList:[],
        DOMESTIC:[],
        INTERNATIONAL:[],
        NEWDOMESTIC_LIST:[],
        citySearchList:[],
    };
  },
  props: {
    cityShow:{
        type: Boolean,
    },
    cityCode:{
        type:String
    },
    cityInput:{
        type:String
    },
    cityDefault:{
        type:Object
    }
  },
  watch: {},
  methods: {
    searchCity(val){
        console.log(val)
        let cityList = CITYAIRLINEJSON

        let searchList = []
        let newValue = val.toLowerCase();
        if (val.length){
            cityList.forEach((item) => {

                item.region = item.region||''
                item.airportnameen = item.airportnameen||''
                item.citynameen = item.citynameen||''
                item.citynamecn = item.citynamecn||''
                item.airportnamecn = item.airportnamecn||''
                item.airportcodethere = item.airportcodethere||''
                if (
                    item.citynameen.toLowerCase().indexOf(newValue) > -1 ||
                    item.airportcodethere.toLowerCase().indexOf(newValue) > -1
                ) {
                    searchList.push(item)
                }
            })

            let newList = []
            searchList.forEach((item)=>{
                // let tem = item.citynameen.indexOf(val);

                var str = item.citynameen
                var str1 = item.airportcodethere
                var keyword  = val;
                keyword = '('+keyword.replace(/([\+\.\*\|\?\-\(\[\^\$])/g,'\\$1' ).replace(/\s+/g,'|')+')';//把匹配关键字中的正则符转义
                var patt=new RegExp(keyword ,'igm');
                var str2=str.replace(patt,`<span style="color:#D8000F;">$1</span>`);
                var str3=str1.replace(patt,`<span style="color:#D8000F;">$1</span>`);

                let name = str2
                let name1 = str3
                // let name = item.citynameen.replace(val.toLowerCase(), `<span style="color:#D8000F;">${val.toLowerCase()}</span>`)
                newList.push({
                    cityairportid:item.cityairportid,
                    airportcodefour: item.airportcodefour,
                    airportcodethere: item.airportcodethere,
                    airportnamecn: item.airportnamecn,
                    citynamecn: item.citynamecn,
                    linetype: item.linetype,
                    citynameen:item.citynameen,
                    airportnameen: item.airportnameen,
                    region: item.region,
                    checked: item.checked,
                    checkedName: `${name} - ${item.airportnameen} (${name1})`,
                })
            })
            this.citySearchList = this.JsonSort(newList,'citynameen')
        }

        console.log(searchList)
    },
    groupCity(e){
        this.cityValue = e.target.value
        if(e.target.value == 0){
            this.tabList = doTab
            this.checkHotCity(domesticHotCity,this.DOMESTIC)
        }else{
            this.tabList = inTab
            this.checkHotCity(InternationalHotCity,this.INTERNATIONAL)
        }
    },
    clickTab(k,v){
        this.tabIndex = k
        if(this.cityValue == 0){
            // 国内
            console.log(v)
            if(v == 'Hot city'){
                //
                this.checkHotCity(domesticHotCity,this.DOMESTIC)
            }else{
                this.checkDoCity(v)
            }
        }else{
            // 国外
            console.log(v)
            if(v == 'Hot city'){
                //
                this.checkHotCity(InternationalHotCity,this.INTERNATIONAL)
            }else{
console.log(v)
                this.checkInCity(v)
            }
        }
    },
    checkHotCity(city,list){
        console.log(city,list)
        let c = []
        city.forEach((item)=>{
            list.forEach((item1)=>{
                if(item == item1.citynamecn){
                    item1.checked = false
                    c.push(item1)
                }
            })
        })
        c.forEach((i)=>{
            if(i.citynameen == this.cityInput){
                i.checked = true
            }
        })
        var hash = {};
        c = c.reduce((arr, current)=> {
            hash[current.citynamecn] ? '' : hash[current.citynamecn] = true && arr.push(current);
            return arr
        }, [])
        this.cityList = c
    },
    checkDoCity(doCity){
        console.log(doCity,'docity')
        let len = doCity.length
        let c = []
        for(var i=0;i<len;i++){
            this.NEWDOMESTIC_LIST.forEach((item)=>{
                if(doCity[i] == item.letter){
                    item.c.checked = false
                    c.push(item.c)
                }
            })
        }
        c.forEach((i)=>{
            if(i.citynameen == this.cityInput){
                i.checked = true
            }
        })
        console.log(c,'chengshi')
        this.cityList = this.JsonSort(c,'citynameen')
    },
    checkInCity(inCity){
        let c = []
        this.INTERNATIONAL.forEach((item)=>{
            if(item.continent == inCity){
                item.checked = false
                c.push(item)
            }
        })
        c.forEach((i)=>{
            if(i.citynameen == this.cityInput){
                i.checked = true
            }
        })
        console.log(c)
        this.cityList = this.JsonSort(c,'citynameen')
    },
    clickCity(k,v){
        let newData = this.cityList
        newData.forEach((item)=>{
            item['checked'] = false
        })
        v['checked'] = true
        newData.splice(k, 1, {
          ...v,
        })
        this.$emit('city-data', v);
        this.cityList = newData
    },
    // closeBox(){
    //     this.$emit('closeBox');
    // },

    /*
        json:需要排序的json
        key:排序项
    */
    JsonSort(json, key) {
        //console.log(json);
        for (var j = 1, jl = json.length; j < jl; j++) {
            var temp = json[j],
                val = temp[key],
                i = j - 1;
            while (i >= 0 && json[i][key] > val) {
                json[i + 1] = json[i];
                i = i - 1;
            }
            json[i + 1] = temp;

        }
        //console.log(json);
        return json;
    },
    checkCity(city){
        console.log(city,'------')
        let letter = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        let DOMESTIC = []
        let INTERNATIONAL = []
        let NEWDOMESTIC_LIST = []
        city.forEach((item)=>{
            item['checked'] = false
            if(item.linetype == 'DOMESTIC'){
                DOMESTIC.push(item)
            }else{
                INTERNATIONAL.push(item)
            }
        })
        letter.forEach((m)=>{
            DOMESTIC.forEach((i) => {
                // console.log(i.citynameen)
                if(i.citynameen){
                    if (m == i.citynameen.slice(0, 1)){
                        NEWDOMESTIC_LIST.push({
                            letter:m,
                            c:i
                        });
                    }
                }else{
                     NEWDOMESTIC_LIST.push({
                         letter:'other',
                         c:i
                     });
                }

            })
        })
        console.log(doTab)
        console.log(NEWDOMESTIC_LIST,'---')

        this.DOMESTIC = DOMESTIC
        this.INTERNATIONAL = INTERNATIONAL
        this.NEWDOMESTIC_LIST = NEWDOMESTIC_LIST
        // 热门城市 - 国内
        this.tabList = doTab
        this.checkHotCity(domesticHotCity,DOMESTIC)
    }
  },
  filters: {},
  computed: {},
  created() {

  },
  mounted() {
        this.checkCity(CITYAIRLINEJSON)
        var that = this
        document.addEventListener('click',(e)=>{
            // 监听点击事件 获取showPanel 边框
            if(that.$refs.showPanel){
                let isSelf = that.$refs.showPanel.contains(e.target)
                if(!isSelf){
                    that.$emit('closeBox');
                }
            }
        })
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// .close_box{
//     position: fixed;
//     width: 100%;
//     height: 100%;
//     left: 0;
//     top: 0;
// }
.city_search{
    z-index: 1;
    position: absolute;
    top: 72px;
    left: 0;
    width:336px;
    max-height:386px;
    overflow-y: auto;
    background:rgba(255,255,255,1);
    box-shadow:0px 6px 8px 0px rgba(0,0,0,0.1);
    border:1px solid rgba(236,238,240,1);
    &::-webkit-scrollbar{
        width: 8px;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: #ECEEF0;
        border-radius: 5px;
    }
    ul{
        li{
            a{
                display: block;
                min-height:64px;
                line-height: 64px;
                font-size:16px;
                color: #333;
                padding-left: 16px;
                &:hover{
                    background-color: #F6F6F6;
                }
            }
        }
    }
}
.city_box{
    z-index: 1;
    position: absolute;
    top: 72px;
    left: 0;
    width:528px;
    min-width:528px;
    height:432px;
    background:rgba(255,255,255,1);
    box-shadow:0px 6px 8px 0px rgba(0,0,0,0.1);
    border:1px solid rgba(236,238,240,1);
    .city_top{
        height: 32px;
        margin-top: 32px;
        padding-top: 7px;
        padding-left: 32px;
        margin-bottom: 16px;
    }
    .city_div{
        ul{
            height: 320px;

            li{
                margin: 0!important;
                box-shadow:  0px 0px 0px 0px #eceef0!important;
                a{
                    display: block;
                }
            }
            &:nth-child(1){
                width: 144px;
                margin-left: 32px;
                border-right: 1px solid #ECEEF0;
                li{
                    width: 143px;
                    height: 48px;
                    line-height: 48px;
                    position: relative;
                    a{
                        font-size:16px;
                        color: #333;
                    }
                }
                .tab_active{

                    a{
                        color: #D8000F;
                    }
                    &::before{
                        content: '';
                        position: absolute;
                        top: 50%;
                        right: 0;
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border-left: 0px solid #ECEEF0;
                        border-right: 8px solid #ECEEF0;
                        border-bottom: 8px solid transparent;
                        border-top: 8px solid transparent;
                        // transform: translateY(-50%);
                        margin-top: -8px;
                    }
                    &::after{
                        content: '';
                        position: absolute;
                        top: 50%;
                        right: -2px;
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border-left: 0px solid #fff;
                        border-right: 8px solid #fff;
                        border-bottom: 8px solid transparent;
                        border-top: 8px solid transparent;
                        // transform: translateY(-50%);
                        margin-top: -8px;
                    }
                }
            }
            &:nth-child(2){
                overflow-y: auto;
                margin-left: 8px;
                width: 342px;
                // scrollbar-face-color: #ECEEF0;/*移动滑块颜色*/
                // scrollbar-shadow-color: #ECEEF0;/*移动滑块边框颜色*/
                &::-webkit-scrollbar{
                    width: 8px;
                    border-radius: 5px;
                }
                &::-webkit-scrollbar-thumb{
                    background-color: #ECEEF0;
                    border-radius: 5px;
                }
                li{
                    &:hover{
                        background-color: #F6F6F6;
                    }
                    a{
                        padding-left: 32px;
                        width: 328px;
                        height: 32px;
                        line-height: 32px;
                        font-size:14px;
                        color: #333;
                        .city_span{
                            max-width: 320px;
                            height: 100%;
                            line-height: 32px;
                        }
                        .city_active{
                            display: inline-block;
                            width: 16px;
                            height: 16px;
                            background: url(../../assets/home/icon_com_choose_sellist.png) no-repeat center;
                            background-size: 100% 100%;
                            margin-top: 8px;
                            margin-right: 16px;
                        }
                    }
                }
            }
        }
    }
}
.tab_active_col{
    color: #D8000F;
}
</style>
